
/*
 * 学生検索
 */
$(function () {
  $('#student-csv-download').click(function(){
    let form = $('.student-form');
    let query = $(form).serializeArray();
    query.push({"name":"format", "value":"csv"});
    window.open($(form)[0].action + '?' + $.param(query), '_blank');
    return false;
  });

  if ($('.offer-input').length) {
    $(document).on('change', '.offer-input', function(){
      let url = new URL(location)
      url.toString();
      if ($(this).prop('checked')) {
      url.searchParams.set("s_flg_offer", "Y");
      } else {
        url.searchParams.delete("s_flg_offer")
      }
      url.searchParams.delete("keep_toast")
      location.href=url.toString();
    });
  }

  if ($('.message-input').length) {
    $(document).on('change', '.message-input', function(){
      let url = new URL(location)
      url.toString();
      if ($(this).prop('checked')) {
      url.searchParams.set("s_no_message", "Y");
      } else {
        url.searchParams.delete("s_no_message")
      }
      url.searchParams.delete("keep_toast")
      location.href=url.toString();
    });
  }
});
